import { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

function ContactPage() {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchContact();
  }, []);

  const fetchContact = async () => {
    try {
      const res = await axiosInstance.get("/api/contact");
      setContact(res.data);
    } catch (err) {
      toast.error("Failed to load contact info");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContact((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await axiosInstance.put("/api/contact", contact);
      setContact(res.data);
      toast.success("Contact info updated");
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to update");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div>
      <h4 className="mb-4">Contact Info</h4>

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSave}>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Address</label>
                <textarea
                  className="form-control"
                  name="address"
                  rows="2"
                  value={contact.address || ""}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="col-md-6">
                <label className="form-label">Primary Phone</label>
                <input
                  type="text"
                  className="form-control"
                  name="phone_primary"
                  value={contact.phone_primary || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Secondary Phone</label>
                <input
                  type="text"
                  className="form-control"
                  name="phone_secondary"
                  value={contact.phone_secondary || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={contact.email || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label">Google Maps Embed URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="map_embed_url"
                  placeholder="https://www.google.com/maps/embed?..."
                  value={contact.map_embed_url || ""}
                  onChange={handleChange}
                />
                <small className="text-muted">
                  Google Maps → Share → Embed a map → copy the src link
                </small>
              </div>

              <div className="col-12">
                <hr />
                <h6 className="mb-3">Social Links</h6>
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <i className="bi bi-facebook me-1"></i> Facebook
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="facebook_url"
                  value={contact.facebook_url || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <i className="bi bi-instagram me-1"></i> Instagram
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="instagram_url"
                  value={contact.instagram_url || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <i className="bi bi-youtube me-1"></i> YouTube
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="youtube_url"
                  value={contact.youtube_url || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  <i className="bi bi-twitter-x me-1"></i> Twitter / X
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="twitter_url"
                  value={contact.twitter_url || ""}
                  onChange={handleChange}
                />
              </div>
            </div>

            {contact.map_embed_url && (
              <div className="mt-4">
                <label className="form-label">Map Preview</label>
                <div className="ratio ratio-16x9" style={{ maxWidth: "500px" }}>
                  <iframe
                    src={contact.map_embed_url}
                    title="Location map"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary mt-4"
              disabled={saving}
            >
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
